import {createSelector} from 'reselect'

export const getError = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.list && state.vehicleParts.list.error,
  error => error
)
